var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"info_title"},[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")]),_c('div',{staticClass:"info_value",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }